import {DxNciDictionaryItem} from "../../../dx-nci-core/domain/dx-nci-dictionary-item";
import {DxComboElementDataProvider} from "../../../dx-forms/domain/combo/dx-combo-element-data-provider";

export class PitNciComboElement extends DxNciDictionaryItem implements DxComboElementDataProvider {
  constructor(dictItem: DxNciDictionaryItem) {
    super();
    this._id = dictItem.id;
    this._name = dictItem.name;
    this._ord = dictItem.ord;
  }

  // геттеры-сеттеры наследуются

  public getId(): number {
    return this._id;
  }

  public getName(): string {
    return this._name;
  }

  public getOrd(): number {
    return this._ord;
  }

  public getSearchString(): string {
    return 'Бла бла бла';
  }
}
